<template>
  <div class="sb-widget">
    <div class="ov-kpis">
      <div class="ov-kpi ov-kpi--primary">
        <div class="ov-kpi__label">Chiffre d'affaires des bagages</div>
        <div class="ov-kpi__value">{{ formatNumber(stats && stats.chiffreAffaires) }}<span>FCFA</span></div>
      </div>
      <div class="ov-kpi">
        <div class="ov-kpi__label">Programmes concernés</div>
        <div class="ov-kpi__value">{{ activePrograms }}</div>
      </div>
      <div class="ov-kpi">
        <div class="ov-kpi__label">Programme le plus rentable</div>
        <div class="ov-kpi__value sb-top" :title="topProgram || ''">{{ topProgram || '—' }}</div>
      </div>
    </div>

    <div class="ov-card">
      <div class="ov-card__head">
        <div>
          <div class="ov-card__title">Chiffre d'affaires des bagages par programme</div>
          <div class="ov-card__sub">En FCFA, du plus élevé au plus faible</div>
        </div>
      </div>
      <div class="ov-card__body">
        <Bar
          v-if="hasData(rankingChart)"
          :chart-id="chartId"
          :chart-data="rankingChart"
          :chart-options="rankingOptions"
          :styles="rankingHeight(rankingChart)"
        />
        <div v-else class="ov-empty ov-chart-empty">Aucun bagage enregistré sur cette période.</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LinearScale,
  CategoryScale,
} from "chart.js";
import {
  SERIES_LUGGAGE,
  chartOptions,
  formatNumber,
  buildRanking,
  mapFromChartData,
  hasData,
  rankingHeight,
} from "@/modules/statistiques/chartTheme";

ChartJS.register(Title, Tooltip, Legend, BarElement, LinearScale, CategoryScale);

export default {
  name: "StatsBagagisteWidget",

  props: {
    // Statistiques bagages brutes de l'API (chiffreAffaires, chiffreAffairesParProgramme)
    dataStatisticBagStation: {
      type: Object,
      default: null,
    },
    // Secours : ancien format préparé par le parent
    chartDataGare: {
      type: Object,
      default: () => ({}),
    },
    chartId: {
      type: String,
      default: "bagagiste-chart",
    },
  },

  components: {
    Bar,
  },

  computed: {
    stats() {
      return this.dataStatisticBagStation;
    },

    revenueByProgram() {
      const map = this.stats && this.stats.chiffreAffairesParProgramme;
      return map && Object.keys(map).length ? map : mapFromChartData(this.chartDataGare, 0);
    },

    rankingChart() {
      return buildRanking(this.revenueByProgram, "Chiffre d'affaires des bagages", SERIES_LUGGAGE);
    },

    activePrograms() {
      return Object.values(this.revenueByProgram).filter((v) => Number(v) > 0).length;
    },

    topProgram() {
      const [top] = Object.entries(this.revenueByProgram)
        .map(([label, value]) => [label, Number(value) || 0])
        .sort((a, b) => b[1] - a[1]);
      return top && top[1] > 0 ? top[0] : null;
    },

    rankingOptions() {
      return chartOptions({ currency: true, legend: false, horizontal: true });
    },
  },

  methods: {
    formatNumber,
    hasData,
    rankingHeight,
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/admin/ui";

.sb-widget {
  font-family: "Montserrat", sans-serif;
}

.sb-top {
  font-size: 18px;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
